import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCouponPerferation = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 74,
	viewBox: "0 0 12 74",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 5V0C0.333333 1.33333 2 4 6 4C10 4 11.6667 1.33333 12 0V5H0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 63,
			transform: "translate(0 5)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 7V66",
			stroke: "black",
			strokeLinecap: "round",
			strokeDasharray: "4 4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 68V74C0.333333 72.4 2 69.2 6 69.2C10 69.2 11.6667 72.4 12 74V68H0Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgCouponPerferation);
export { ForwardRef as ReactComponent };
